// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Box } from 'components/layout/Box/Box'
import { Icon } from 'components/shared/Icon/Icon'

import styles from './CategoryStatistics.module.scss'

export const CategoryStatistics = ({
  children,
  editButton = undefined,
  className = undefined,
  icon,
  label,
  value,
}) => (
  <React.Fragment>
    <Box
      align="center"
      className={cx(styles.category, {
        [className]: Boolean(className),
      })}
    >
      <Icon className={styles.icon} icon={icon} size={24} />
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
      {editButton}
    </Box>
    {R.not(R.isNil(children)) ? children : null}
  </React.Fragment>
)
